import React from 'react';
import PropTypes from 'prop-types';

const InputCheckBox = ({ name, value, label, onChange, disabled }) => {   

    //Tekið upp frá Magna, lausn sem hann gerði í IHK.
    let id = "check_" + name + new Date().getTime() + Math.floor(Math.random() * 100);

    const handleChange = e => {
        //console.log(e); 
        if (onChange){
            onChange(e.target.checked);
        }
      };


    
    if (value == undefined|| value.error != undefined){
        value = false;
    }    

    return (
        <div>
            <input id={id} 
                name={name} 
                type="checkbox" 
                checked={value} 
                onChange={handleChange}
                disabled={disabled} />
            <label htmlFor={id}>{label}</label>
        </div>  
      );
};

InputCheckBox.propTypes = {
   name: PropTypes.string,
   value: PropTypes.bool,
   onChange: PropTypes.func.isRequired,   
   label : PropTypes.string,
   disabled: PropTypes.bool
};

export default InputCheckBox;
